import { useContext, useEffect } from "react";
import { Context } from "../../../../context";
import { Layout } from "../../../../containers/layout/dashboard";
import { TopUpWrapper } from "./styled";

export const TopUp = () => {
    const { setActiveNavItem } = useContext(Context);

    useEffect(() => {
        setActiveNavItem("Accounting");
    }, [setActiveNavItem]);

    return (
        <Layout
            id="top-up"
        >
            <TopUpWrapper>

            </TopUpWrapper>
        </Layout>
    )
}